import model0 from "../../../../common/assets/model3d/WifiboxNG.glb";
import model1 from "../../../../common/assets/model3d/SpectraNG.glb";
import model2 from "../../../../common/assets/model3d/PulseNG.glb";
import model3 from "../../../../common/assets/model3d/IBU-NG.glb";
import model4 from "../../../../common/assets/model3d/Baumer_StrainLink.glb";
import { useRef } from "react";

import { useGLTF } from "@react-three/drei";
import { PerspectiveCamera } from "@react-three/drei";

export const CeprItem = (params) => {
  // eslint-disable-next-line no-array-constructor
  let NodesKey = new Array();

  const model =
    params.modelChoise === 0
      ? model0
      : params.modelChoise === 1
      ? model1
      : params.modelChoise === 2
      ? model2
      : params.modelChoise === 3
      ? model3
      : model4;

  let group = useRef();

  let {  nodes } = useGLTF(model);

  // const recursy = (params) => {
  //   if (params.children.length && params.children.length !== 0) {
  //     // eslint-disable-next-line array-callback-return
  //     params.children.map((el) => {
  //       recursy(el);
  //     });
  //   } else if (params.parent.length && params.parent.length !== 0) {
  //     // eslint-disable-next-line array-callback-return
  //     params.parent.map((el) => {
  //       recursy(el);
  //     });
  //   } else {
  //     NodesKey.push(params);
  //   }
  // };

  let keys = Object.keys(nodes);

  for (var j = 0; j < keys.length; j++) {
    if (nodes[keys[j]].type === "Mesh") {
      NodesKey.push(nodes[keys[j]]);
    }
  }

  return (
    <>
      <group
        ref={group}
        dispose={5}
        scale={1}
        position={
          params.modelChoise === 0
            ? [0, -70, 0]
            : params.modelChoise === 1
            ? [0, -20, 0]
            : params.modelChoise === 2
            ? [0, 0, 0]
            : params.modelChoise === 3
            ? [0, -10, 0]
            : params.modelChoise === 4
            ? [0, 0, 0]
            : null
        }
      >
        <group scale={1}>
          {NodesKey.map((i,ind) => {
            return NodesKey.length !== 0 &&
              i.geometry !== undefined &&
              i.material !== undefined ? (
              <group scale={1} key={ind}> 
                <mesh
                  geometry={i.geometry}
                  material={i.material}
                  position={i.position}
                  rotation={i.rotation}
                  quaternion={i.quaternion}
                  scale={i.scale}
                  // parent={i.parent}
                  // up={i.up}
                />
              </group>
            ) : null;
          })}
        </group>
        <PerspectiveCamera
          makeDefault={true}
          far={8000.65}
          near={50.94}
          fov={
            params.modelChoise === 0
              ? 50
              : params.modelChoise === 1
              ? 50
              : params.modelChoise === 2
              ? 32
              : params.modelChoise === 3
              ? 38
              : params.modelChoise === 4
              ? 40
              : 50
          }
          onUpdate={(c) => c.updateProjectionMatrix()}
          // position={
          //   params.modelChoise == 4
          //     ? [80, 100, 100]
          //     : params.modelChoise == 2 ? [10, 100, 100] :[30, 130, 280]
          // }
          position={[30, 130, 280]}
        />
      </group>
    </>
  );
};
